module.exports = __webpack_public_path__ + "img/ezikel.43f88f22.png";